import {Route} from 'react-router'
import NotFound from './NotFound'

const NotFoundRoute = <Route path='*' component={NotFound} />

export default NotFoundRoute
